import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surgical-schedule-master',
  templateUrl: './surgical-schedule-master.component.html',
  styleUrls: ['./surgical-schedule-master.component.scss']
})
export class SurgicalScheduleMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  opensurgicalscheduleModal(){
    document.getElementById("surgicalscheduleModal").style.display='block'; 
  }
  closesurgicalscheduleModal(){
    document.getElementById("surgicalscheduleModal").style.display='none';
  }

}
